// Single client for all browser search. Every call hits a scoped server-side
// Rails endpoint (app/controllers/search_controller.rb) which runs MeiliSearch
// with the server's key — the browser never sees a key or talks to MeiliSearch
// directly. Each function returns the parsed JSON body ({ hits, ... }).

async function getJSON(path, params) {
  const qs = new URLSearchParams()
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== "") qs.append(k, v)
  })
  const res = await fetch(`${path}?${qs.toString()}`, {
    headers: { Accept: "application/json" },
  })
  if (!res.ok) throw new Error(`Search request failed: ${res.status}`)
  return res.json()
}

// Plant search — nav typeahead, pickers, dup detection, planner.
// Returns { hits, estimatedTotalHits, limit, offset }.
export function searchPlants({ q, limit, offset, excludeId, parentId } = {}) {
  return getJSON("/search/plants", {
    q,
    limit,
    offset,
    exclude_id: excludeId,
    parent_id: parentId,
  })
}

// Plant data-attribute key autocomplete. Returns { hits: [{ key }] }.
export function autosuggestKeys(q) {
  return getJSON("/search/autosuggest_keys", { q })
}

// Plant data-attribute value autocomplete (optionally scoped to a key).
// Returns { hits: [{ value }] }.
export function autosuggestValues(q, key) {
  return getJSON("/search/autosuggest_values", { q, key })
}

// Plant-link relationship type autocomplete. Returns { hits: [{ link_type }] }.
export function searchLinkTypes(q) {
  return getJSON("/search/link_types", { q })
}

// Marketplace geo search for the map. bbox is the raw "lat,lng,lat,lng,zoom"
// string. Returns { hits: [{ id, link, seller, _geo }] }.
export function searchMarketplace({ q, bbox } = {}) {
  return getJSON("/search/marketplace", { q, bbox })
}
